export const OrnamentalDivider = ({ label }) => (
  <div className="ornament-divider my-10 max-w-md mx-auto" data-testid="ornamental-divider">
    <span className="text-[#D4AF37] text-lg">✦</span>
    {label ? (
      <span className="serif italic text-[#6E2638] tracking-wide text-sm">{label}</span>
    ) : null}
    <span className="text-[#D4AF37] text-lg">✦</span>
  </div>
);

export default OrnamentalDivider;
